import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {AngularFireAuth} from '@angular/fire/compat/auth';
import {Observable, throwError} from 'rxjs';
import {catchError, switchMap} from 'rxjs/operators';
import {environment} from '../../../environments/environment';
import {UnrAuthService} from '../auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class UnrTokenInterceptor implements HttpInterceptor {

  constructor(private angularFireAuth: AngularFireAuth,
              private authService: UnrAuthService) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    if (request.url.indexOf(`${environment.apiUrl}`) === -1) {
      return next.handle(request);
    }

    return this.angularFireAuth
      .idToken
      .pipe(
        switchMap((token: string) => {
          request = request.clone({
            setHeaders: {
              Authorization: `Bearer ${token}`
            }
          });

          return next.handle(request);
        }),
        catchError((error: HttpErrorResponse) => {
          if (error.status === 401) {
            this.authService.signOut().then();
          }
          return throwError(error);
        })
      );
  }
}
